module.exports = __webpack_public_path__ + "static/media/figma.1f357a4d.svg";